import React, { useState } from 'react';

// Custom Input Component
export const CustomInput = ({ type, placeholder, onSubmit, theme }) => {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    if (value.trim()) {
      onSubmit(value.trim());
      setValue('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="custom-input">
      <input
        type={type}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        className="custom-input-field"
        style={{ borderColor: theme.primary }}
      />
      <button
        onClick={handleSubmit}
        className="custom-input-btn"
        style={{ backgroundColor: theme.primary }}
        disabled={!value.trim()}
      >
        Send
      </button>
    </div>
  );
};

// Message Content Component
export const MessageContent = ({ message, handleMenuAction, theme }) => {
  switch (message.type) {
    case 'menu':
      return (
        <div className="message-menu">
          <div className="message-text">{message.text}</div>
          <div className="menu-options">
            {message.options?.map((option, index) => (
              <button
                key={index}
                className="menu-option-btn"
                onClick={() => handleMenuAction(option.action, option)}
                style={{ backgroundColor: theme.accent }}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      );

    case 'packages':
      return (
        <div className="message-packages">
          <div className="message-text">{message.text}</div>
          <div className="package-options">
            {message.options?.map((pkg, index) => (
              <div key={index} className="package-card"
               onClick={() => handleMenuAction('selectPackage', { package: pkg })}
              >
                <div className="package-info">
                  <div className="package-name">{pkg.data} - {pkg.duration}</div>
                  <div className="package-price">sh {pkg.price}</div>
                </div>
              </div>
            ))}
          </div>
          <button
            className="back-btn"
            onClick={() => handleMenuAction('backToMain')}
            style={{ backgroundColor: theme.text }}
          >
            ← Back to Menu
          </button>
        </div>
      );

    case 'input':
      return (
        <div className="message-input">
          <div className="message-text">{message.text}</div>
          <CustomInput
            type={message.inputType}
            placeholder={message.inputPlaceholder}
            onSubmit={(value) => handleMenuAction(message.inputAction, { value })}
            theme={theme}
          />
        </div>
      );

    case 'success':
      return (
        <div className="message-success">
          <div className="message-text">{message.text}</div>
        </div>
      );

    case 'transactionHistory':
      return (
        <div className="message-transaction-history">
          <div className="message-text">{message.text}</div>
          <div className="transaction-history">
            {message.options?.map((transaction, index) => (
              <div key={index} className="transaction-item">
                <div className="transaction-header">
                  <span className="transaction-type">{transaction.transactionDesc}</span>
                  <span className="transaction-amount">sh {transaction.amount}</span>
                </div>
                <div className="transaction-details">
                  <div>Receipt: {transaction.mpesaReceiptNumber}</div>
                  <div>Account: {transaction.account}</div>
                  <div>Date: {new Date(transaction.completedAt).toLocaleDateString()}</div>
                </div>
              </div>
            ))}
          </div>
          <button
            className="back-btn"
            onClick={() => handleMenuAction('backToMain')}
            style={{ backgroundColor: theme.text }}
          >
            ← Back to Menu
          </button>
        </div>
      );

    case 'error':
      return (
        <div className="message-error">
          <div className="message-text">{message.text}</div>
        </div>
      );

    default:
      return <div className="message-text">{message.text}</div>;
  }
};